import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { Users, Calendar, CreditCard, Building2, TrendingUp } from "lucide-react";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/admin/stats`);
        setStats(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64">
      <div className="w-8 h-8 border-2 border-[#002FA7] border-t-transparent rounded-full animate-spin"></div>
    </div>;
  }

  const cards = [
    { label: "Total Users", value: stats?.total_users || 0, icon: Users },
    { label: "Active Subscriptions", value: stats?.active_subscriptions || 0, icon: CreditCard },
    { label: "Total Employees", value: stats?.total_employees || 0, icon: TrendingUp },
    { label: "Total Rosters", value: stats?.total_rosters || 0, icon: Calendar },
    { label: "Total Teams", value: stats?.total_teams || 0, icon: Building2 },
  ];

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <h1 className="text-2xl font-bold text-white tracking-tight">Admin Dashboard</h1>
        <p className="text-sm text-zinc-500 mt-1">Platform overview</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-px bg-zinc-800 border border-zinc-800 rounded overflow-hidden">
        {cards.map((card, idx) => {
          const Icon = card.icon;
          return (
            <div key={idx} className="bg-zinc-900 p-5">
              <Icon className="w-4 h-4 text-zinc-600 mb-3" />
              <p className="text-2xl font-bold tabular-nums text-white">{card.value}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">{card.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminDashboard;
